import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/sales/Hero';
import { PainNarrative } from '../components/sales/PainNarrative';
import { MechanismSection } from '../components/sales/MechanismSection';
import { WhatInsideSection } from '../components/sales/WhatInsideSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { PricingCTA } from '../components/sales/PricingCTA';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
import { StickyBar } from '../components/sales/StickyBar';
// Extend window type for fbq
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}
export function SalesPage() {
  useEffect(() => {
    // Inject Meta Pixel script
    if (!window.fbq) {
      const n: any = function (...args: unknown[]) {
        if ((n as any).callMethod) {
          ;
          (n as any).callMethod.apply(n, args);
        } else {
          ;
          (n as any).queue.push(args);
        }
      };
      window.fbq = n;
      window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq?.('init', '923286363476807');
    window.fbq?.('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-night font-sans text-brand-cream" data-id="element-160">
      <Hero data-id="element-161" />
      <main data-id="element-162">
        <PainNarrative data-id="element-163" />
        <MechanismSection data-id="element-164" />
        <WhatInsideSection data-id="element-165" />
        <TestimonialsSection data-id="element-166" />
        <PricingCTA data-id="element-167" />
        <GuaranteeSection data-id="element-168" />
      </main>

      <footer className="bg-brand-night border-t border-brand-border text-brand-muted py-12 text-center text-sm" data-id="element-169">
        <div className="max-w-4xl mx-auto px-4" data-id="element-170">
          <p className="mb-4 text-brand-parchment" data-id="element-171">
            &copy; {new Date().getFullYear()} Deep Sleep Protocol. All rights
            reserved.
          </p>
          <p className="text-xs text-brand-muted" data-id="element-172">
            Disclaimer: This product is for educational purposes only. It is not
            intended to diagnose, treat, cure, or prevent any disease. Consult
            your physician before starting any new health protocol.
          </p>
        </div>
      </footer>

      <StickyBar data-id="element-173" />
    </div>;
}